import { atom } from "recoil";

export const tokenUpdate = atom<boolean>({
  key: "tokenUpdate",
  default: false,
});
